export default {
  path: "/user/cpa/sitio-web",
  component: () => import("@/views/user/cpa/sitio-web/SitioWebLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "sitio-web-dashboard",
      component: () => import("@/views/user/cpa/sitio-web/SitioWebDashboard.vue"),
    },
    {
      path: "inicio",
      name: "sitio-web-inicio",
      component: () => import("@/views/user/cpa/sitio-web/HomeConfigView.vue"),
    },
    {
      path: "configuracion",
      name: "sitio-web-config",
      component: () => import("@/views/user/cpa/sitio-web/SiteConfigView.vue"),
    },
    {
      path: "identidad-visual",
      name: "sitio-web-identidad",
      component: () => import("@/views/user/cpa/sitio-web/SiteThemeView.vue"),
    },
    {
      path: "navegacion",
      name: "sitio-web-navegacion",
      component: () => import("@/views/user/cpa/sitio-web/SiteNavEditorView.vue"),
    },
    {
      path: "destacados",
      name: "sitio-web-destacados",
      component: () => import("@/views/user/cpa/sitio-web/FeaturedItemsView.vue"),
    },
    {
      path: "circulares",
      name: "sitio-web-circulares",
      component: () => import("@/views/user/cpa/sitio-web/CircularListView.vue"),
    },
    {
      path: "circulares/nueva",
      name: "sitio-web-circular-nueva",
      component: () => import("@/views/user/cpa/sitio-web/CircularEditorView.vue"),
    },
    {
      path: "circulares/:slug",
      name: "sitio-web-circular-editar",
      component: () => import("@/views/user/cpa/sitio-web/CircularEditorView.vue"),
      props: true,
    },
    {
      path: "noticias",
      name: "sitio-web-noticias",
      component: () => import("@/views/user/cpa/sitio-web/NewsListView.vue"),
    },
    {
      path: "noticias/nueva",
      name: "sitio-web-noticia-nueva",
      component: () => import("@/views/user/cpa/sitio-web/NewsEditorView.vue"),
    },
    {
      path: "noticias/:slug",
      name: "sitio-web-noticia-editar",
      component: () => import("@/views/user/cpa/sitio-web/NewsEditorView.vue"),
      props: true,
    },
    {
      path: "blog",
      name: "sitio-web-blog",
      component: () => import("@/views/user/cpa/sitio-web/BlogListView.vue"),
    },
    {
      path: "blog/nuevo",
      name: "sitio-web-blog-nuevo",
      component: () => import("@/views/user/cpa/sitio-web/BlogEditorView.vue"),
    },
    {
      path: "blog/:slug",
      name: "sitio-web-blog-editar",
      component: () => import("@/views/user/cpa/sitio-web/BlogEditorView.vue"),
      props: true,
    },
    {
      path: "paginas",
      name: "sitio-web-paginas",
      component: () => import("@/views/user/cpa/sitio-web/PageListView.vue"),
    },
    {
      path: "paginas/nueva",
      name: "sitio-web-pagina-nueva",
      component: () => import("@/views/user/cpa/sitio-web/PageEditorView.vue"),
    },
    {
      path: "paginas/:slug",
      name: "sitio-web-pagina-editar",
      component: () => import("@/views/user/cpa/sitio-web/PageEditorView.vue"),
      props: true,
    },
    {
      path: "documentos",
      name: "sitio-web-documentos",
      component: () => import("@/views/user/cpa/sitio-web/DocumentListView.vue"),
    },
    {
      path: "documentos/nuevo",
      name: "sitio-web-documento-nuevo",
      component: () => import("@/views/user/cpa/sitio-web/DocumentEditorView.vue"),
    },
    {
      path: "documentos/:slug",
      name: "sitio-web-documento-editar",
      component: () => import("@/views/user/cpa/sitio-web/DocumentEditorView.vue"),
      props: true,
    },
    {
      path: "directiva",
      name: "sitio-web-directiva",
      component: () => import("@/views/user/cpa/sitio-web/BoardPublicInfoView.vue"),
    },
  ],
};
